import { render, staticRenderFns } from "./lazyLoading.vue?vue&type=template&id=01160d5d&"
import script from "./lazyLoading.vue?vue&type=script&lang=js&"
export * from "./lazyLoading.vue?vue&type=script&lang=js&"
import style0 from "./lazyLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports